import React from "react";
import { green, grey, red } from "@mui/material/colors";
import ToggleButton from "@mui/material/ToggleButton";

import { StyledToggleButton } from "./preferenceFieldButton.styles";

export const enum TrafficLightValue {
  avoid = "avoid",
  neutral = "neutral",
  prefer = "prefer",
}

interface TrafficLightData {
  hue: typeof red | typeof grey | typeof green;
  color?: string;
  cost: number;
  text: string;
}

export const trafficLightData: { [key in TrafficLightValue]: TrafficLightData } = {
  [TrafficLightValue.avoid]: { hue: red, color: "white", cost: 10, text: "Avoid" },
  [TrafficLightValue.neutral]: { hue: grey, color: "white", cost: 1, text: "Neutral" },
  [TrafficLightValue.prefer]: { hue: green, color: "white", cost: 0.25, text: "Prefer" },
};

interface PreferenceFieldButtonProps extends React.ComponentProps<typeof ToggleButton> {
  trafficLightValue: TrafficLightValue;
  value: string | number;
}

const PreferenceFieldButton: React.FC<PreferenceFieldButtonProps> = ({ trafficLightValue, value, ...props }: PreferenceFieldButtonProps) => {
  const { cost, color, hue, text } = trafficLightData[trafficLightValue];
  const isSelected = cost === value || cost.toString() === value;
  return (
    <StyledToggleButton
      {...props}
      value={cost.toString()}
      hue={hue}
      selected={isSelected}
      sx={{ textTransform: "none", "&.Mui-selected": { color } }}
    >
      {text}
    </StyledToggleButton>
  );
};

export default PreferenceFieldButton;
